import { render } from "./LHCourseMaterials.vue?vue&type=template&id=62fd97e5"
import script from "./LHCourseMaterials.vue?vue&type=script&lang=js"
export * from "./LHCourseMaterials.vue?vue&type=script&lang=js"

import "./LHCourseMaterials.vue?vue&type=style&index=0&id=62fd97e5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__